import { render, staticRenderFns } from "./UserCalendar.vue?vue&type=template&id=4ac8043a&scoped=true&"
import script from "./UserCalendar.vue?vue&type=script&lang=ts&"
export * from "./UserCalendar.vue?vue&type=script&lang=ts&"
import style0 from "./UserCalendar.vue?vue&type=style&index=0&id=4ac8043a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac8043a",
  null
  
)

export default component.exports